import 'agora-rtc-sdk-ng'

import i18next from 'i18next'
import { isNil } from 'lodash'
import qs from 'query-string'

import { isSafari } from './device'
import { ROUTE_PATH } from './paths'
import { LocalStorage } from './storage'

window?.AgoraRTC?.setLogLevel?.(2)

export const getConferenceCallUrl = (
  conferenceCallId: string,
  shouldRedirect: boolean,
  params = {}
) => {
  const query = qs.stringify({
    ...(shouldRedirect
      ? {
          redirect: window.btoa(
            `${window.location.pathname}${window.location.search}`
          ),
        }
      : {}),
    ...params,
  })

  return `${ROUTE_PATH.CONFERENCE(conferenceCallId)}${query ? `?${query}` : ''}`
}

export const openConferenceCallRoom = (
  conferenceCallId: string,
  params?: {
    inviteId?: string
    targetId?: string
  }
) => {
  if (isCallInUse()) {
    alertCallInUse()
    return
  } else if (!window.AgoraRTC.checkSystemRequirements()) {
    alert(i18next.t('open_conference_call.not_meet_requirement'))
    return
  }

  window.conferrenceCallRef = window.open(
    getConferenceCallUrl(conferenceCallId, isSafari, params),
    isSafari ? '_self' : '_blank' // This is due to Safari would attempt to open a new tab, then gets blocked by the browser.
  )

  window.conferrenceCallRef?.focus?.()

  return window.conferrenceCallRef
}

export const setCallInUse = (inUse: number | false) => {
  if (inUse) {
    LocalStorage.callInUse.set(true)
    LocalStorage.willLeaveConferenceId.set(inUse)
  } else {
    LocalStorage.callInUse.remove()
  }
}

export const isCallInUse = () => {
  return (
    (window.conferrenceCallRef && !window.conferrenceCallRef.closed) ||
    !isNil(LocalStorage.callInUse.get(undefined))
  )
}

export const alertCallInUse = () => {
  const count = LocalStorage.callInUseAlertCount.get(0)
  alert(i18next.t('alert_call_in_user'))
  // this logic will prevent "call in use" state accidentally unclear when leave call
  // show alert only 3 times and clear call in use state
  if (count < 2) {
    LocalStorage.callInUseAlertCount.set(count + 1)
  } else {
    LocalStorage.callInUseAlertCount.remove()
    setCallInUse(false)
  }
}

export const isDevicesAvailable = async () => {
  const defaultValues = {
    audioInput: false,
    audioOutput: false,
    videoInput: false,
  }

  try {
    const availableDevices = await navigator.mediaDevices.enumerateDevices()

    return availableDevices.reduce(
      (prev, cur) => ({
        audioInput: prev.audioInput || cur.kind === 'audioinput',
        audioOutput: prev.audioOutput || cur.kind === 'audiooutput',
        videoInput: prev.videoInput || cur.kind === 'videoinput',
      }),
      defaultValues
    )
  } catch {
    return defaultValues
  }
}
